module.exports = __webpack_public_path__ + "img/主页图片3.04b9b676.png";